import React from 'react';
import './TimerDisplay.css';
import { formatTime } from '../../utils/timeFormatter';
import { useTheme } from '../../contexts/ThemeContext';

const TimerDisplay = ({ time }) => {
    const { darkMode } = useTheme();
    const themeClass = darkMode ? 'dark-theme' : 'light-theme';

    // Różne klasy dla różnych przedziałów czasowych
    let timeClass = '';
    if (time <= 5) {
        timeClass = 'critical-time'; // Ostatnie 5 sekund - bardzo pilne
    } else if (time <= 10) {
        timeClass = 'warning-time'; // 6-10 sekund - ostrzegawcze
    } else if (time < 30) {
        timeClass = 'low-time'; // Poniżej 30 sekund - mało czasu
    }

    return (
        <div className={`timer-display ${themeClass} ${timeClass}`}>
            {formatTime(time)}
        </div>
    );
};

export default TimerDisplay;